import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminPeople = lazy(() => import("@/pages/admin/AdminPeople"));

export const Route = createFileRoute("/admin/kunder")({
  component: () => <AdminPeople />,
});
